import {
  PatientDocument
} from '../components/patient-drilldown/documents/documents-accordion-contents-v2';
import {getPayment} from '../../payment-hub/services/payment-service';
import {PatientEncounter} from '../components/models/patient-encounter';
import {PatientViewModel} from '../components/models/patient-view-model';

export const addAuthDocSmsEligibility = async (
    selectedPatient: PatientViewModel,
    selectedEncounter: PatientEncounter,
    patientDocuments: PatientDocument[]
): Promise<PatientDocument[]> => {

  return await Promise.all(

    patientDocuments.map((document: PatientDocument) =>{

      if(document.authorizationDocumentStatus){

        if(['spa', 'inst'].includes(document.authorizationDocumentStatus?.authorizationDocuments?.typeOfDoc)){

          const guarantor = Array.isArray(selectedEncounter?.patientChampion) ? selectedEncounter?.patientChampion?.find((champion) => champion?.isGuarantor === true) : undefined
          const accountHolderContact = guarantor ? guarantor.contact : selectedPatient.contact
          const isEligibleForSms =
              Boolean(accountHolderContact.smsConsentFl &&
              ((accountHolderContact.primPhoneNum && accountHolderContact.primPhoneType === 'mobile') || (accountHolderContact.secPhoneNum && accountHolderContact.secPhoneType === 'mobile')))

          return {
            ...document,
            isEligibleForSms
          }

        }else if(['otp'].includes(document.authorizationDocumentStatus?.authorizationDocuments?.typeOfDoc)){

          return getPayment({
            paymentId: document.authorizationDocumentStatus.paymentId
          }).then((payment) => {
            const paymentUserId = payment?.userPaymentMethod?.userId;

            if(!paymentUserId) throw new Error("userId missing in userPaymentMethod")

            let isPayerEligibleForSms = false

            if (selectedPatient.userId === paymentUserId) {

              isPayerEligibleForSms = Boolean(
                  selectedPatient.contact.smsConsentFl &&
                  ((selectedPatient.contact.primPhoneNum &&
                      selectedPatient.contact.primPhoneType ===
                      'mobile') || (
                      selectedPatient.contact.secPhoneNum &&
                      selectedPatient.contact.secPhoneType === 'mobile'
                  ))
              )

            } else {

              for (let i = 0; i < selectedEncounter.patientChampion.length; i++) {

                if (selectedEncounter.patientChampion[i].userId === paymentUserId) {

                  isPayerEligibleForSms = Boolean(
                      selectedEncounter.patientChampion[i].contact.smsConsentFl &&
                      ((selectedEncounter.patientChampion[i].contact.primPhoneNum &&
                          selectedEncounter.patientChampion[i].contact.primPhoneType ===
                          'mobile') || (
                          selectedEncounter.patientChampion[i].contact.secPhoneNum &&
                          selectedEncounter.patientChampion[i].contact.secPhoneType === 'mobile'
                      ))
                  )
                  break;
                }
              }
            }

            return {
              ...document,
              isEligibleForSms: isPayerEligibleForSms
            }

          }).catch((e) => {

            console.log("Could not determine sms eligibility: ", e)

            return {
              ...document,
              isEligibleForSms: false
            }

          })

        }else{
          return document
        }

      }else{
        return document
      }
    })
  )

}